import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';
import * as yup from 'yup';

const config = {
    name: 'catalog',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'syncHeo' }
    ],
    endpoints: {
        catalog: '/v2/catalog',
        catalogItem: '/v2/catalog/[id]',
        syncHeo: '/v2/catalog/sync/heo',
        syncItemImages: '/v2/catalog/[id]/sync-images'
    },
    defaults: {
        catalogItem: {
            itemId: '',
            type: 'product',
            name: '',
            description: '',
            thumbnail: '',
            source: 'manual',
            rawData: {}
        }
    },
    validations: {
        catalogItem: yup.object().shape({
            name: yup.string().required('Numele este obligatoriu'),
            type: yup.string().required('Tipul este obligatoriu')
        })
    }
};

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils()
};

export default Config;
